<template>
  <v-container ma-0 pa-0 fluid class="pt-sans">    
    <v-slide-x-transition mode="out-in">
      <div v-if="loading" class="top-blur circular">
        <v-progress-circular indeterminate :size="70" :width="3" color="error"></v-progress-circular>
      </div>
    </v-slide-x-transition>
    <v-layout row wrap class="border-bottom">
      <v-flex offset-md1 md10 pt-2 pb-2>
        <span class="nome pull-left">
          Seja bem-vindo(a),&nbsp;<strong class="capitalize">{{ nomeUsuario }}</strong> - <strong>{{ tradingName }}</strong>
        </span>
        <span @click="sair" class="pull-right pl-2 link">
          sair
        </span>
        <span @click="minhaConta" class="pull-right pl-2 link">
          minha conta
        </span>
         <span @click="ShowManualEvent" class="pull-right pl-2 link">
          ajuda
        </span>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex offset-md1 md1>
        <img src="../../assets/logo.png" alt="" style="width:60px;height:60px;" class="mt-2 mb-2">
      </v-flex>
      <v-flex md9>
        <v-tabs grow :value="rota" slider-color="red" :hide-slider="!sliderMenu" height="82" class="menu-tabs">
          <v-tab v-for="tab in tabs" :key="'/Painel/' + tab.menu" :to="'/Painel/' + tab.url" :ripple="false">
            <v-icon class="mr-2">{{tab.icon}}</v-icon>{{ tab.nome }}
          </v-tab>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-slide-x-transition mode="out-in">
          <router-view></router-view>
        </v-slide-x-transition>
      </v-flex>
    </v-layout>
    <order-details></order-details>

      <Feedback
        :token="token"
        :generalFeedback="generalFeedback"
        class="feedback-btn"/>  

        <manual v-bind:toShow.sync="showModal">
        </manual>      
        
  </v-container>  
</template>

<script>
import orderDetails from '@/components/painel/sharedComponents/orderDetails/'
import Feedback from '@/components/hotsite/Feedback'
import Manual from '@/components/manual/manual'

export default {
  name: 'Painel',
  components: {
    'order-details': orderDetails,
    Feedback,
    'manual': Manual
  },
  data () {
    return {
      showModal: false,
      tabs: [
        {
          nome: 'Início',
          icon: 'home',
          menu: 'Inicio',
          url: 'Inicio/'
        },
        {
          nome: 'Pedidos',
          icon: 'room_service',
          menu: 'Pedidos',
          url: 'Pedidos/Novos/'
        },
        // {
        //   nome: 'Orçamentos',
        //   icon: 'format_list_numbered',
        //   url: 'Orcamentos'
        // },
        {
          nome: 'Itens',
          icon: 'card_giftcard',
          menu: 'Itens',
          url: 'Itens/Relacao/'
        },
        {
          nome: 'Agendamento',
          icon: 'insert_invitation',
          menu: 'Agendamento',
          url: 'Agendamento/Agendados/'
        },
        // {
        //   nome: 'Negócios',
        //   icon: 'next_week',
        //   url: 'Negocios'
        // },
        // {
        //   nome: 'Atendimento',
        //   icon: 'forum',
        //   url: 'Atendimento'
        // },
        {
          nome: 'Relatórios',
          icon: 'trending_up',
          url: 'Relatorios/Condominios'
        }
      ],
      manterLogin: false,
      generalFeedback: true
    }
  },
  methods: {
    sair () {
      this.$store.dispatch('logOut').then(() => {
        this.$router.push('/Login')
      })
    },
    minhaConta () {
      this.$router.push('/Painel/Conta/Empresa')
    },
    ShowManualEvent () {
      this.showModal = false
      this.showModal = true
    }
  },
  computed: {
    // showModal () {
    //   return true
    // },
    loading () {
      return this.$store.getters.loadingMounted
    },
    nomeUsuario () {
      return this.$store.getters.nome
    },
    tradingName () {
      return this.$store.getters.tradingName
    },
    rota () {
      let rota = this.$store.state.route.path
      rota = rota.split('/')
      return '/Painel/' + rota[2]
    },
    sliderMenu () {
      let rota = this.$store.state.route.path
      rota = rota.split('/')
      return this.tabs.filter(elem => elem.menu === rota[2]).length > 0
    },
    token () {
      return this.$store.getters.token
    }
  },
  mounted () {
    this.$store.dispatch('getCompanyData')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.circular>div{
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -35px;
  margin-top: -70px;
}
.searchInput{
  width: 259px;
  float: right;
}
.capitalize{
  text-transform: capitalize;
}
.border-bottom{
  border-bottom: 2px solid #f4f5f9
}
.menu-tabs .tabs__slider{
  background-color: #ea565d!important;
}
.menu-tabs .tabs__item{
  color: #747f8b!important;
}
.menu-tabs .tabs__item--active{
  color: #e92c37!important;
}
.menu-tabs .tabs__item--active i{
  color: #e92c37!important;
}
.menu-tabs{
  background-color: #fff!important;
}
.menu-tabs i {
  display: none;
}
.feedback-btn {
  position: fixed;
  right: 1em;
  bottom: 1.5em;
  z-index: 1;
}
@media all and (max-width: 720px) {
  .feedback-btn {
    position: relative;
    transform: translateX(1.5em);
  }
}
@media only screen and (min-width: 1150px){
  .menu-tabs i {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?4d2cb514